import { render, staticRenderFns } from "./FooterResult.vue?vue&type=template&id=c8ffe03e&"
import script from "./FooterResult.vue?vue&type=script&lang=js&"
export * from "./FooterResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports